(function(){
  var nav=document.querySelector('[data-fm-colnav]');
  var grid=document.querySelector('.fm-best-sellers-grid');
  var heading=document.querySelector('.fm-best-sellers-heading');
  if(!nav||!grid) return;

  var origHTML=grid.innerHTML;
  var origHeading=heading?heading.textContent:'';
  var showN=parseInt(grid.getAttribute('data-fm-show'),10)||24;
  var cache={};      // tab -> Promise<string html>
  var tabHtml={};    // tab -> resolved html (for instant local search)
  var current='best-sellers';
  var moreBtn=nav.querySelector('.fm-colnav__more');

  function pillFor(tab){ return nav.querySelector('.fm-colnav__pill[data-tab="'+tab+'"]'); }

  function setMore(open){
    if(!moreBtn) return;
    nav.classList.toggle('fm-colnav--open',open);
    moreBtn.setAttribute('aria-expanded',open?'true':'false');
    moreBtn.classList.toggle('fm-colnav__pill--open',open);
  }

  function setActive(pill){
    nav.querySelectorAll('.fm-colnav__pill--active').forEach(function(p){p.classList.remove('fm-colnav__pill--active');});
    pill.classList.add('fm-colnav__pill--active');
    if(pill.closest('.fm-colnav__extra')) setMore(true);
  }

  // Per-country sales ranking (assets/fm-rank.json, regenerated by fm_rank_refresh.py).
  // rank[country][tab] = product handles ordered by 30d units -> 90d units -> global; unsold products keep collection order after them.
  var rankUrl=nav.getAttribute('data-rank-url');
  var rankPromise=rankUrl?fetch(rankUrl,{credentials:'same-origin'}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;}):Promise.resolve(null);
  function country(){
    try{ var c=(window.Shopify&&Shopify.country)||''; return String(c).toUpperCase(); }catch(e){ return ''; }
  }
  function orderFor(rank,tab){
    if(!rank||!rank.rank) return null;
    var cc=country();
    var byCountry=rank.rank[cc]&&rank.rank[cc][tab];
    if(byCountry&&byCountry.length) return byCountry;
    return (rank.rank.ALL&&rank.rank.ALL[tab])||null;
  }
  function handleOf(a){
    var m=(a.getAttribute('href')||'').match(/\/products\/([^/?#]+)/);
    return m?m[1]:'';
  }

  // Best Sellers pool (server-rendered in global order) -> this country's order, first showN visible
  function trimTo(cards,n){ cards.forEach(function(a,i){ a.hidden=i>=n; if(i<8){ var img=a.querySelector('img'); if(img) img.setAttribute('loading','eager'); } }); }
  var rankData=null;
  rankPromise.then(function(rank){
    rankData=rank;
    var order=orderFor(rank,'best-sellers');
    var box=document.createElement('div'); box.innerHTML=origHTML;
    var cards=applyBadges(sortCards(Array.prototype.slice.call(box.querySelectorAll('.fm-best-sellers-card')),order),rank);
    if(!cards.length) return;
    trimTo(cards,showN);
    box.innerHTML=''; cards.forEach(function(a){ box.appendChild(a); });
    origHTML=box.innerHTML;
    if(current==='best-sellers'){ grid.innerHTML=origHTML; }
    grid.classList.add('is-ranked');
  });

  // Pull every product card out of a fetched collection page, de-duped by URL
  function extractCards(html){
    var doc=new DOMParser().parseFromString(html,'text/html');
    var seen={},out=[];
    doc.querySelectorAll('.fm-best-sellers-card').forEach(function(a){
      var href=a.getAttribute('href')||'';
      var key=href.split('?')[0];
      if(!key||seen[key]) return;
      seen[key]=1;
      a.classList.remove('fm-best-sellers-card--featured');
      out.push(a);
    });
    return out;
  }

  // Data badges (from fm-rank.json): country #1 / local favourite / trending. Only cards that would otherwise say ON SALE are changed.
  function applyBadges(cards,rank){
    if(!rank||!rank.badges) return cards;
    var cc=country();
    var mine=rank.badges[cc]||{}, all=rank.badges.ALL||{};
    cards.forEach(function(a){
      var h=handleOf(a); var spec=mine[h]||all[h]; if(!spec) return;
      var badge=a.querySelector('.fm-best-sellers-badge');
      if(!badge||badge.textContent.trim()!=='ON SALE') return;
      badge.textContent=spec.b;
      badge.className='fm-best-sellers-badge fm-best-sellers-badge--'+spec.c;
      var info=a.querySelector('.fm-best-sellers-info'); if(!info) return;
      var note=info.querySelector('.fm-stock-note');
      if(!note){ note=document.createElement('div'); info.appendChild(note); }
      note.className='fm-stock-note fm-stock-note--'+spec.nc;
      note.innerHTML='<span class="fm-stock-dot fm-stock-dot--'+spec.nc+'"></span><span></span>';
      note.lastChild.textContent=spec.n;
    });
    return cards;
  }

  function sortCards(cards,order){
    if(!order) return cards;
    var pos={}; order.forEach(function(h,i){ pos[h]=i; });
    return cards.map(function(a,i){ return {a:a,i:i,p:(handleOf(a) in pos)?pos[handleOf(a)]:Infinity}; })
      .sort(function(x,y){ return x.p===y.p ? x.i-y.i : x.p-y.p; })
      .map(function(x){ return x.a; });
  }

  function load(tab){
    var pill=pillFor(tab);
    if(!pill) return Promise.resolve('');
    if(!cache[tab]){
      cache[tab]=Promise.all([
          fetch(pill.getAttribute('data-src'),{credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}})
            .then(function(r){ if(!r.ok) throw new Error(r.status); return r.text(); })
            .then(extractCards),
          rankPromise
        ])
        .then(function(res){
          var cards=applyBadges(sortCards(res[0],orderFor(res[1],tab)),res[1]);
          // first row loads eagerly so a swapped tab doesn't show blank tiles
          cards.forEach(function(a,i){ var img=a.querySelector('img'); if(img&&i<8) img.setAttribute('loading','eager'); });
          var html=cards.map(function(a){ return a.outerHTML; }).join('');
          tabHtml[tab]=html;
          return html;
        })
        .catch(function(e){ delete cache[tab]; throw e; });
    }
    return cache[tab];
  }

  function scrollToNav(){
    var top=nav.getBoundingClientRect().top;
    if(top<0){ window.scrollTo({top:window.pageYOffset+top-90,behavior:'smooth'}); }
  }

  function updateURL(tab,replace){
    var url=new URL(window.location.href);
    url.searchParams.delete('q');
    if(tab==='best-sellers') url.searchParams.delete('tab'); else url.searchParams.set('tab',tab);
    var s=url.pathname+(url.search||'')+url.hash;
    try{ history[replace?'replaceState':'pushState']({fmTab:tab},'',s); }catch(e){}
  }

  function show(tab,opts){
    opts=opts||{};
    var pill=pillFor(tab);
    if(!pill) return;
    current=tab;
    setActive(pill);
    if(!opts.silent) updateURL(tab,false);

    if(tab==='best-sellers'){
      grid.classList.remove('is-loading');
      grid.classList.remove('is-other');
      grid.innerHTML=origHTML;
      if(heading) heading.textContent=origHeading;
      if(opts.scroll) scrollToNav();
      return;
    }

    grid.classList.add('is-loading');
    load(tab).then(function(html){
      if(current!==tab) return;
      if(!html){ window.location.href=pill.href; return; }
      grid.classList.add('is-other');
      grid.innerHTML=html;
      if(heading) heading.textContent=pill.getAttribute('data-label');
      grid.classList.remove('is-loading');
      if(opts.scroll) scrollToNav();
    }).catch(function(){
      if(current!==tab) return;
      window.location.href=pill.href;
    });
  }

  // ---- Inline search: bar under the pills, results replace the grid as you type (same cards, via /search?view=fm-cards)
  var bar=nav.querySelector('[data-fm-searchbar]');
  var input=nav.querySelector('[data-fm-search-input]');
  var searchPill=nav.querySelector('[data-fm-search]');
  var searchTimer=null, searchAbort=null, lastQuery='', beforeSearch=null;

  var catalog=null, catalogPromise=null;
  function loadCatalog(){
    if(catalogPromise) return catalogPromise;
    var seen={},out=[];
    function page(n){
      return fetch('/collections/all?view=fm-cards&page='+n,{credentials:'same-origin'})
        .then(function(r){ return r.ok?r.text():''; })
        .then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          var box=doc.querySelector('[data-fm-catalog]');
          Array.prototype.slice.call(doc.querySelectorAll('[data-fm-catalog] .fm-best-sellers-card')).forEach(function(a){ var h=handleOf(a); if(!h||seen[h]) return; seen[h]=1; out.push(a); });
          var total=box?parseInt(box.getAttribute('data-count'),10)||0:0;
          return (total>n*250&&n<4)?page(n+1):null;
        });
    }
    catalogPromise=page(1).then(function(){ if(out.length) catalog=out; return catalog; })
      .catch(function(){ if(out.length){ catalog=out; return catalog; } catalogPromise=null; return null; });
    return catalogPromise;
  }
  function toggleSearch(open){
    if(!bar||!input) return;
    bar.hidden=!open;
    if(open) loadCatalog().then(function(){ if(input.value.trim()&&!bar.hidden){ lastQuery=''; runSearch(input.value); } });
    searchPill.classList.toggle('fm-colnav__pill--active',open);
    searchPill.setAttribute('aria-expanded',open?'true':'false');
    if(open){
      if(beforeSearch===null) beforeSearch={tab:current,html:grid.innerHTML,heading:heading?heading.textContent:''};
      nav.querySelectorAll('.fm-colnav__pill[data-tab]').forEach(function(p){ p.classList.remove('fm-colnav__pill--active'); });
      try{ input.focus({preventScroll:true}); }catch(e){ input.focus(); }
    } else {
      input.value=''; lastQuery='';
      if(searchAbort){ searchAbort.abort(); searchAbort=null; }
      if(beforeSearch){ grid.classList.toggle('is-other',beforeSearch.tab!=='best-sellers'); grid.innerHTML=beforeSearch.html; if(heading) heading.textContent=beforeSearch.heading; var p=pillFor(beforeSearch.tab); if(p) p.classList.add('fm-colnav__pill--active'); beforeSearch=null; }
      grid.classList.remove('is-loading');
    }
  }
  // Tokens of the card's title+handle, plus joined aliases so designations match however they're typed:
  // "F/A-18F" -> f, a, 18f, fa, a18f, fa18f, f18f ; "SR-71" -> sr71 ; "B-2" -> b2 ; "A380" -> a380
  function cardTokens(a){
    if(a.__fmTok) return a.__fmTok;
    var raw=(((a.querySelector('.fm-best-sellers-title')||{}).textContent||'')+' '+handleOf(a)).toLowerCase();
    var t=raw.split(/[^a-z0-9]+/).filter(Boolean);
    var out=t.slice();
    for(var i=0;i<t.length;i++){
      if(i+1<t.length) out.push(t[i]+t[i+1]);
      if(i+2<t.length){ out.push(t[i]+t[i+1]+t[i+2]); out.push(t[i]+t[i+2]); }
    }
    a.__fmTok=out; return out;
  }
  function matchesAll(a,terms){
    var toks=cardTokens(a);
    var hay=' '+toks.join(' ')+' ';
    var ok=terms.every(function(t,i){
      var n=t.replace(/[^a-z0-9]/g,''); if(!n) return true;
      if(i===terms.length-1) return toks.some(function(k){ return k.indexOf(n)===0; });   // last word: prefix of a token/alias
      return hay.indexOf(n)!==-1;                                                        // earlier words: anywhere
    });
    if(ok) return true;
    // whole query with separators stripped ("f 18", "f/a-18") as one alias prefix
    var whole=terms.join('').replace(/[^a-z0-9]/g,'');
    return whole.length>1 && toks.some(function(k){ return k.indexOf(whole)===0; });
  }
  // Typo tolerance: edit distance (with transpositions) <= 1 for short words, 2 for 6+ letters, against token prefixes
  function editDist(a,b,max){
    var la=a.length, lb=b.length; if(Math.abs(la-lb)>max) return max+1;
    var prev2=null, prev=[], cur; for(var j=0;j<=lb;j++) prev[j]=j;
    for(var i=1;i<=la;i++){
      cur=[i]; var rowMin=i;
      for(var k=1;k<=lb;k++){
        var cost=a.charAt(i-1)===b.charAt(k-1)?0:1;
        var v=Math.min(prev[k]+1,cur[k-1]+1,prev[k-1]+cost);
        if(i>1&&k>1&&a.charAt(i-1)===b.charAt(k-2)&&a.charAt(i-2)===b.charAt(k-1)) v=Math.min(v,prev2[k-2]+1);
        cur[k]=v; if(v<rowMin) rowMin=v;
      }
      if(rowMin>max) return max+1;
      prev2=prev; prev=cur;
    }
    return prev[lb];
  }
  function fuzzyMatchesAll(a,terms){
    var toks=cardTokens(a);
    return terms.every(function(t){
      var n=t.replace(/[^a-z0-9]/g,''); if(!n) return true;
      if(n.length<4) return toks.some(function(k){ return k.indexOf(n)===0; });
      var max=n.length>=6?2:1;
      return toks.some(function(k){ return k.length>=n.length-max && editDist(n,k.slice(0,n.length),max)<=max; });
    });
  }
  // Cards already on the page: the Best Sellers pool + any tab fetched so far (instant, no network)
  function localCards(){
    var box=document.createElement('div'); box.innerHTML=(beforeSearch?beforeSearch.html:origHTML);
    Object.keys(tabHtml).forEach(function(k){ box.insertAdjacentHTML('beforeend',tabHtml[k]); });
    var seen={},out=[];
    Array.prototype.slice.call(box.querySelectorAll('.fm-best-sellers-card')).forEach(function(a){ var h=handleOf(a); if(!h||seen[h]) return; seen[h]=1; a.hidden=false; out.push(a); });
    return out;
  }
  function renderResults(cards,q,partial,searching,approx){
    grid.classList.add('is-other');
    if(cards.length){
      grid.innerHTML=cards.map(function(a){ return a.outerHTML; }).join('');
      if(heading) heading.textContent=approx ? 'Closest matches for \u201c'+q+'\u201d' : cards.length+' result'+(cards.length===1?'':'s')+' for \u201c'+q+'\u201d';
    } else if(searching){
      grid.innerHTML='<div class="fm-colnav__empty">Searching all models for \u201c'+q.replace(/</g,'&lt;')+'\u201d\u2026</div>';
      if(heading) heading.textContent='Search';
    } else if(partial){
      grid.innerHTML='<div class="fm-colnav__empty">Keep typing to search all 300+ models\u2026</div>';
      if(heading) heading.textContent='Search';
    } else {
      grid.innerHTML='<div class="fm-colnav__empty">No models found for \u201c'+q.replace(/</g,'&lt;')+'\u201d.<br>Try an airline, aircraft or livery \u2014 or <a href="/search?q='+encodeURIComponent(q)+'">search the whole store</a>.</div>';
      if(heading) heading.textContent='No results for \u201c'+q+'\u201d';
    }
  }
  function runSearch(q){
    q=q.trim();
    if(q===lastQuery) return;
    lastQuery=q;
    if(q.length<1){
      if(beforeSearch){ grid.classList.toggle('is-other',beforeSearch.tab!=='best-sellers'); grid.innerHTML=beforeSearch.html; if(heading) heading.textContent=beforeSearch.heading; }
      grid.classList.remove('is-loading');
      return;
    }
    var terms0=q.toLowerCase().split(/\s+/).filter(Boolean);
    if(!q.replace(/[^a-z0-9]/gi,'')){ // punctuation / accents only: nothing to match on
      if(searchAbort){ searchAbort.abort(); searchAbort=null; }
      grid.classList.remove('is-loading');
      renderResults([],q,true);
      return;
    }
    var pool=catalog||localCards();
    var approx=false;
    var hits=pool.filter(function(a){ return matchesAll(a,terms0); });
    if(!hits.length&&catalog&&q.length>=4){ hits=pool.filter(function(a){ return fuzzyMatchesAll(a,terms0); }); approx=hits.length>0; }
    var local=applyBadges(sortCards(hits.map(function(a){ return a.cloneNode(true); }),orderFor(rankData,'all')),rankData);
    local.forEach(function(a,i){ a.hidden=false; var img=a.querySelector('img'); if(img&&i<8) img.setAttribute('loading','eager'); });
    if(catalog&&local.length){ // whole catalogue in memory: exact (or typo-corrected), instant
      if(searchAbort){ searchAbort.abort(); searchAbort=null; }
      grid.classList.remove('is-loading');
      renderResults(local,q,false,false,approx);
      return;
    }
    if(q.length<3){ // Shopify's prefix search needs 3+ chars: show instant local matches, or a hint
      if(searchAbort){ searchAbort.abort(); searchAbort=null; }
      grid.classList.remove('is-loading');
      renderResults(local,q,!catalog);
      return;
    }
    renderResults(local,q,false,true); // instant local hits (or a Searching… note), then the server results replace it
    if(searchAbort) searchAbort.abort();
    searchAbort=(window.AbortController?new AbortController():null);
    grid.classList.add('is-loading');
    var terms=q.toLowerCase().split(/\s+/).filter(Boolean);
    var url='/search?view=fm-cards&type=product&options%5Bprefix%5D=last&q='+encodeURIComponent(q);
    fetch(url,{credentials:'same-origin',signal:searchAbort?searchAbort.signal:undefined})
      .then(function(r){ return r.text(); })
      .then(function(html){
        if(q!==lastQuery) return;
        var doc=new DOMParser().parseFromString(html,'text/html');
        var box=doc.querySelector('[data-fm-search-results]');
        var cards=box?Array.prototype.slice.call(box.querySelectorAll('.fm-best-sellers-card')):[];
        // Shopify ORs the words and adds typo-tolerant near-misses ("qantas" -> Qatar). Keep only cards whose
        // title/handle contains every word (last word as a word-prefix); fall back to Shopify's list only if that leaves nothing.
        var strict=cards.filter(function(a){ return matchesAll(a,terms); });
        var approxServer=false;
        if(strict.length) cards=strict; else approxServer=cards.length>0;
        // Union with what's already loaded locally (server caps at 48; tabs can hold more), de-duped by handle
        var seenH={}; cards.forEach(function(a){ seenH[handleOf(a)]=1; });
        local.forEach(function(a){ if(!seenH[handleOf(a)]){ seenH[handleOf(a)]=1; cards.push(a); } });
        // Same country ranking as the rest of the page: best sellers first, unranked keep Shopify's order at the end
        cards=applyBadges(sortCards(cards,orderFor(rankData,'all')),rankData);
        cards.forEach(function(a,i){ var img=a.querySelector('img'); if(img&&i<8) img.setAttribute('loading','eager'); });
        renderResults(cards,q,false,false,approxServer&&!local.length);
        grid.classList.remove('is-loading');
      })
      .catch(function(err){ if(err&&err.name==='AbortError') return; grid.classList.remove('is-loading'); if(q===lastQuery&&!local.length) renderResults([],q,false); });
  }
  if(input){
    input.addEventListener('input',function(){ clearTimeout(searchTimer); var v=input.value; searchTimer=setTimeout(function(){ runSearch(v); },220); });
    input.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); clearTimeout(searchTimer); runSearch(input.value); input.blur(); } if(e.key==='Escape'){ toggleSearch(false); } });
    var clr=nav.querySelector('[data-fm-search-clear]'); if(clr) clr.addEventListener('click',function(){ toggleSearch(false); });
  }

  nav.addEventListener('click',function(e){
    var search=e.target.closest('[data-fm-search]');
    if(search){ e.preventDefault(); toggleSearch(bar.hidden); return; }
    var more=e.target.closest('.fm-colnav__more');
    if(more){ e.preventDefault(); setMore(!nav.classList.contains('fm-colnav--open')); return; }
    var pill=e.target.closest('.fm-colnav__pill[data-tab]');
    if(!pill) return;
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1) return; // let new-tab clicks through
    e.preventDefault();
    var tab=pill.getAttribute('data-tab');
    if(bar&&!bar.hidden){ beforeSearch=null; bar.hidden=true; input.value=''; lastQuery=''; searchPill.classList.remove('fm-colnav__pill--active'); if(searchAbort){searchAbort.abort();searchAbort=null;} grid.classList.remove('is-loading'); show(tab,{scroll:true}); return; }
    if(tab===current) return;
    show(tab,{scroll:true});
  });

  // Warm the cache before the click lands
  function prefetch(e){
    var pill=e.target.closest('.fm-colnav__pill[data-src]');
    if(pill) load(pill.getAttribute('data-tab')).catch(function(){});
  }
  nav.addEventListener('mouseenter',prefetch,true);
  nav.addEventListener('touchstart',prefetch,{passive:true,capture:true});

  window.addEventListener('popstate',function(){
    var tab=new URL(window.location.href).searchParams.get('tab')||'best-sellers';
    if(tab!==current) show(tab,{silent:true});
  });

  window.__fmOpenSearch=function(v){
    var m=document.querySelector('details-modal.header__search details'); if(m) m.removeAttribute('open');
    if(bar.hidden) toggleSearch(true);
    input.value=v; runSearch(v);
    try{ window.scrollTo({top:nav.getBoundingClientRect().top+window.pageYOffset-90,behavior:'smooth'}); }catch(e){}
  };
  // Deep link: /collections/all?q=qantas (header search submits here) -> inline search open + populated
  var initialQ=new URL(window.location.href).searchParams.get('q');
  if(initialQ&&initialQ.trim()&&bar&&input){
    toggleSearch(true);
    input.value=initialQ.trim();
    runSearch(input.value);          // instant local pass; the catalogue re-runs it when loaded
    try{ input.blur(); }catch(e){}   // don't pop the keyboard on a landing
  }
  // Deep link: /collections/all?tab=military
  var initial=new URL(window.location.href).searchParams.get('tab');
  if(initial&&initial!=='best-sellers'&&pillFor(initial)){
    show(initial,{silent:true});
  }
})();
